export enum ComponentSelected {
    DIALOG = 'DIALOG',
    DROPDOWN = 'DROPDOWN',
}
